import types from "./types";

function set_categories_action(payload) {
  return { type: types.SET_CATEGORIES, payload };
}

export { set_categories_action };

// old
export default {
  get_categories_request: (payload) => ({
    type: types.GET_CATEGORIES_REQUEST,
    payload,
  }),
  set_categories: set_categories_action,
};
